export default __webpack_public_path__ + "static/media/left.75e878c0.svg";